import { useSyncExternalStore } from 'react'
import type { RoomStateItemX, TipMessage } from '../../../types/mfc'
import { pubSub } from '../../app-state/pubSub'
import { getRoomState } from '../../app-state/state.room'
import { isLounge } from '../../mfcLogic/userProperties/user'

const getRoomTips = (id: number) => resolveRoomStateSelector(id, 'tips')
export const subRoom = (callback: () => void) =>
    pubSub.ROOM.on('state', callback)

const resolveRoomStateSelector =
    <T extends keyof RoomStateItemX>(id: number, attribute: T) =>
    (): RoomStateItemX[T] => {
        const state = getRoomState()[id] || { isLounge: isLounge(id), id }
        return state[attribute]
    }

export const useRoomSelector = <T extends keyof RoomStateItemX>(
    id: number,
    attribute: T,
): RoomStateItemX[T] => {
    return useSyncExternalStore(
        subRoom,
        resolveRoomStateSelector(id, attribute),
        resolveRoomStateSelector(id, attribute),
    )
}

export const useRoomTips = (id: number): Array<TipMessage> => {
    return useSyncExternalStore(subRoom, getRoomTips(id), getRoomTips(id))
}
